function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#search-icon_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.38 8.901a5.64 5.64 0 10-1.735 1.598l4.159 4.134a1.18 1.18 0 101.669-1.67l-4.094-4.062zm-4.608.385a3.638 3.638 0 11-.007-7.277 3.638 3.638 0 01.01 7.277h-.003z",
  fill: "#B8B7B7"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "search-icon_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})));

function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSearchIcon;